import {
    FLEET_DETAIL_START,
    FLEET_DETAIL_SUCCESS,
    FLEET_DETAIL_ERROR,
    DOCUMENT_EXPIRED_START,
    DOCUMENT_EXPIRED_SUCCESS,
    DOCUMENT_EXPIRED_ERROR
} from  '../Constants/FleetDetailConstant'
  
const initialState = {
    loading: false,
    data: [],
    expiredData : []
};
  
export default function FleetDetailReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case FLEET_DETAIL_START:
        return {
          ...state,
          loading: true,
        };
      case FLEET_DETAIL_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case FLEET_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case DOCUMENT_EXPIRED_START:
        return {
          ...state,
          loading: true,
        };
      case DOCUMENT_EXPIRED_SUCCESS:
        return {
          ...state,
          expiredData: action.payload,
          loading: false,
        };
      case DOCUMENT_EXPIRED_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
    
      default:
        return state;
    }
}
  